import PlainTextArea from './PlainTextArea';

export default PlainTextArea;
